import { OfflineArea } from 'components/layout';
import { createBrowserHistory } from 'history';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import DevTools from 'mobx-react-devtools';
import * as React from 'react';
import { Route, Router, Switch } from 'react-router';
import { SalesDashboard, SalesLead } from 'routes/sales';
import { Login, Logout } from 'routes/user';
import { PrivateRoute } from './components/route/private/PrivateRoute';
import Main from './routes';
import { PageNotFound } from './routes/errors/PageNotFound/PageNotFound';
import { IAppOnlyStore } from './stores/AllStores';
import authentication = require('feathers-authentication-client');
import hooks = require('feathers-hooks');
import socketio = require('feathers-socketio/client');
import feathers = require('feathers/client');
import localForage = require('localforage');
import io = require('socket.io-client');

// History
export const browserHistory = createBrowserHistory({
  forceRefresh: false,
});

// Interfaces
export interface IAuthConfig {
  strategy: string;
  email?: string;
  password?: string;
}

// Environment variables
declare const process: any;

const isDevEnvironment: boolean =
  typeof process !== 'undefined' &&
  typeof process.env !== 'undefined' &&
  typeof process.env.NODE_ENV !== 'undefined' &&
  process.env.NODE_ENV === 'development'
    ? true
    : false;

const apiHost: string =
  typeof process !== 'undefined' &&
  typeof process.env !== 'undefined' &&
  typeof process.env.API_HOST !== 'undefined'
    ? process.env.API_HOST
    : 'http://localhost:3030/';

// API connection
export const socket = io(apiHost);
export const app: any = feathers();

// Initialize FeathersJS client
app
  .configure(socketio(socket, { timeout: 60000 }))
  .configure(hooks())
  .configure(
    authentication({
      storage: localForage as any,
    })
  );

// Component
@inject('store')
@observer
export default class App extends React.Component<IAppOnlyStore, {}> {
  @observable private isLocalStorageTokenChecked: boolean = false;

  constructor(props: IAppOnlyStore) {
    super(props);

    const { utilities } = this.props.store;

    if (typeof this.props.store !== 'undefined') {
      // Relogin user if they have a token stored locally
      this.props.store.user
        .relogin()
        .then((response) => {
          this.isLocalStorageTokenChecked = true;
        })
        .catch((error) => {
          this.isLocalStorageTokenChecked = true;
        });

      // Track connectivity to the back-end via web sockets and inform user when things go wrong
      socket.on('connect', () => {
        utilities.changeConnectionStatus(true);
      });
      socket.on('reconnect', () => {
        utilities.changeConnectionStatus(true);
      });
      socket.on('disconnect', () => {
        utilities.changeConnectionStatus(false);
      });
      socket.on('error', () => {
        utilities.changeConnectionStatus(false);
      });
    }
  }

  public render() {
    const { user, utilities } = this.props.store;

    return (
      <div id="app">
        {this.isLocalStorageTokenChecked && (
          <Router history={browserHistory}>
            <Switch>
              <Route path="/user/login" exact={true} component={Login} />
              <Route path="/user/logout" exact={true} component={Logout} />

              <PrivateRoute
                path="/sales"
                exact={true}
                component={SalesDashboard}
              />

              <PrivateRoute
                path="/sales/lead/:providerId"
                component={SalesLead}
              />

              <Route path="/" exact={true} component={Main} />

              <Route component={PageNotFound} />
            </Switch>
          </Router>
        )}

        <OfflineArea show={utilities.showOfflineArea} />

        {isDevEnvironment && <DevTools />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/App.tsx